import React, {useCallback, useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    IconButton,
    FormGroup,
    FormControlLabel,
    Checkbox,
    MenuItem,
    CircularProgress, CardContent, Card, Dialog, DialogActions, DialogContent, DialogContentText
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowUpward } from "@material-ui/icons";
import {CHAT_TYPE, LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import {
    clearChatStateInsiderService,
    createProgramService,
    CurationPromptStreamService,
    getActiveChatInsiderProgramService,
    loadChatStateInsiderService,
    saveChatStateInsiderService,
} from "../../../services/learning_programs.service";
import Loader from "../../../components/Loader/Loader.comp";
import { TARGET_AGE } from "../../../utils/META/cat_109";
import { REGIONS } from "../../../utils/META/cat_101";
import {
    SUBJECTS,
    TEACHING_METHODS,
    DELIVERY_FORMATS,
    TECH_ENVIRONMENTS,
    SENSITIVITIES,
    FOCUS_FIELDS,
} from "../../../utils/dq_program_constants";
import {Slider} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import Avatar from '@mui/material/Avatar';
import PersonIcon from "@material-ui/icons/Person";
import SmartToyIcon from "@material-ui/icons/Person";


// --- Styles ---
const useStyles = makeStyles((theme) => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 105px)',
        padding: '32px',
        [theme.breakpoints.down('sm')]: {
            padding: '16px',
            height: 'calc(100vh - 105px)',
        },
    },
    contentContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'center',
        marginBottom: (props) => props.chatInitiated ? '0' : '0',
        transition: 'all 0.3s ease',
        overflowY: 'auto',
        paddingBottom: '20px',
        width: '100%', // Added width
        maxWidth: '100%', // Added maxWidth
        [theme.breakpoints.up('sm')]: {
            padding: '0 16px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 24px',
        },
    },
    chatContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        overflowY: 'auto',
        padding: '20px',
        marginBottom: '20px',
        [theme.breakpoints.down('sm')]: {
            padding: '10px',
            maxWidth: '100%',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            maxWidth: '100%',
        },
        // [theme.breakpoints.up('md')]: {
        //     maxWidth: '800px',
        // },
    },
    iconButton: {
        color: 'white !important',
        backgroundColor: '#EE6628 !important',
        '&:hover': {
            backgroundColor: '#EE6628 !important',
        },
        padding: '10px !important',
        borderRadius: '0% !important',
    },
    inputField: {
        '& .MuiInputBase-root': {
            color: '#5A5A5A',
            backgroundColor: '#fff',
            borderRadius: '15px',
            padding: '0px',
        },
        '& .MuiOutlinedInput-multiline':{
            padding: '0px',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FFAB46',
                borderWidth:'2px',
            },
            '&:hover fieldset': {
                borderColor: '#FFAB46',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FFAB46',
            },
        },
    },
    optionsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: '10px',
        marginTop: '15px',
        marginBottom: '15px',
        padding: '0 20px',
    },
    optionButton: {
        minWidth: '180px',
        padding: '12px 20px',
        borderRadius: '16px',
        fontSize: '14px',
        textTransform: 'none',
        backgroundColor: '#FE686F !important',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#ff7a80 !important',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        fontSize: '45px !important',
        marginBottom: '24px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    chatBubble: {
        padding: '5px 15px',
        borderRadius: '12px',
        maxWidth: '75%',
        fontSize: '16px',
        marginBottom: '10px',
        // overflow:'unset !important',
    },
    botChat: {
        backgroundColor: '#fce5cd !important',
        alignSelf: 'flex-start',
        textAlign: 'left',
        marginTop: '10px',
        marginBottom: '10px',
        marginRight: 'auto',  // Always stick to the left
    },
    userChat: {
        backgroundColor: '#f4cccc !important',
        alignSelf: 'flex-end',
        textAlign: 'left',
        marginTop: '10px',
        marginBottom: '10px',
        marginLeft: 'auto',  // Always stick to the right
    },
    formContainer: {
        display:'flex',
        flexDirection:'column',
        width:'500px',
        marginTop: '10px',
        padding: '10px',
        backgroundColor: 'transparent',
        borderRadius: '12px',
        [theme.breakpoints.down('sm')]: {
            width:'100%',
        },
    },
    disabledForm: {
        opacity: 0.7,
        pointerEvents: 'none',
    },
    examplesContainer: {
        padding: '24px',
        margin: '24px 0',
        maxWidth: '800px',
        background: '#f7f9fa',
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(100,100,100,0.07)',
        textAlign: 'center',
        display: (props) => props.chatInitiated ? 'none' : 'block',
        transition: 'all 0.3s ease',
    },
    editIcon: {
        marginLeft: '10px',
        cursor: 'pointer',
        color: '#EE6628 !important',
    },
    thinkingIndicator: {
        alignSelf: 'flex-start',
        padding: '12px 16px',
        color: '#666',
        fontStyle: 'italic',
    },
}));

// First, add the pillButtonSx function (if you don't have it already)
const pillButtonSx = (isSelected) => ({
    background: isSelected ? '#FE686F' : '#fff',
    color: isSelected ? '#fff' : '#222',
    border: isSelected ? 'none' : '2px solid #f2f2f2',
    borderRadius: '16px',
    py: 2,
    px: 2,
    mb: 2,
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
        background: isSelected ? '#ff7a80' : '#f5f5f5',
    },
    '&.Mui-disabled': {
        opacity: 0.5,
        color: '#666',
        backgroundColor: '#fff',
        border: '2px solid #666',
        cursor: 'not-allowed',
    }
});

const parseMarkdown = (text) => {
    if (!text) return '';
    let formatted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    formatted = formatted.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');
    formatted = formatted.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
    formatted = formatted.replace(/`([^`]+)`/g, '<code>$1</code>');
    formatted = formatted.replace(/^(\-{3,}|\*{3,})$/gm, '<hr>');
    formatted = formatted.replace(/^(#{1,6})\s+(.*?)$/gm, (match, hashes, content) => {
        const level = hashes.length;
        return `<h${level}>${content}</h${level}>`;
    });
    formatted = formatted.replace(/^>\s+(.*?)$/gm, '<blockquote>$1</blockquote>');
    formatted = formatted.replace(/^\d+\.\s+(.*?)$/gm, '<li>$1</li>');
    formatted = formatted.replace(/^[\-\*]\s+(.*?)$/gm, '<li>$1</li>');
    formatted = formatted.replace(/<li>.*?<\/li>/gs, match => {
        if (match.includes('</li><li>')) {
            return `<ul>${match}</ul>`;
        }
        return match;
    });
    formatted = formatted.replace(/\n/g, '<br>');
    return formatted;
};

const initialState = {
    Theme: "",
    Competencies: [],
    Age: '',
    Countries: '',
    CurriculumType: '',
    SubjectArea: null,
    SubjectAreaOther: null,
    SubjectContextTopic: '',
    StructureType: null,
    SessionDuration: null,
    NumSessions: null,
    SuggestApproxHours: null,
    FocusProblem: null,
    FocusSolution: null,
    FocusMindset: null,
    FocusKS_F: null,
    FocusKS_C: null,
    FocusKS_P: null,
    FocusKS_M: null,
    FocusAB_A: null,
    FocusAB_P: null,
    FocusAB_I: null,
    FocusAB_B: null,
    ExposureTopic: null,
    ExposureTopicDetail: null,
    Format: [0, 0, 0, 0, 0, 0, 0], // Seven options, all unselected by default
    FormatOther: null,
    TechEnvironment: null,
    BestDelivery: [0,0,0,0,0,0,0,0,0],
    BestDeliveryOther: null,
    CulturalSensitivity: [0,0,0,0,0,0],
    CulturalSensitivityOther: null,
    CulturalSensitivityDetails: null
};

const CURRICULUM_TYPE_LABELS = {
    1: "integrated into existing subjects (e.g., Math, English, Science)",
    2: "developed as a standalone AI Literacy curriculum",
};


const DQProProgCreationV2 = () => {
    const history = useHistory();
    const [chatInitiated, setChatInitiated] = useState(false);
    const classes = useStyles({ chatInitiated });

    const [isNewProgram, setIsNewProgram] = useState(false);

    const [chatHistory, setChatHistory] = useState([]);
    const [input, setInput] = useState('');
    const [showChat, setShowChat] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isBotThinking, setIsBotThinking] = useState(false);
    const [programIdState, setProgramIdState] = useState(null);
    const [step, setStep] = useState(0);
    const [wizard, setWizard] = useState({...initialState, CourseCode: ''});
    const [detectedCompetencies, setDetectedCompetencies] = useState([]);

    const [subjectOther, setSubjectOther] = useState(null);
    const [sessionDuration, setSessionDuration] = useState(null);
    const [numSessions, setNumSessions] = useState(null);
    const [exposureDetail, setExposureDetail] = useState("");
    const [formatOther, setFormatOther] = useState("");
    const [bestDeliveryOther, setBestDeliveryOther] = useState("");
    const [culturalOther, setCulturalOther] = useState("");
    const [culturalDetail, setCulturalDetail] = useState("");
    const [openStartOverDialog, setOpenStartOverDialog] = useState(false);

    // For multi-selects
    const [selectedFormats, setSelectedFormats] = useState([]);
    const [selectedDeliveries, setSelectedDeliveries] = useState([]);
    const [selectedSensitivities, setSelectedSensitivities] = useState(Array(SENSITIVITIES.length).fill(0));

    // const chatEndRef = useRef(null);
    const newMessageRef = useRef(null);

    const [activeEditStep, setActiveEditStep] = useState(null);

    const [isEditing, setIsEditing] = useState(false);
    const [editStep, setEditStep] = useState(null);

    const [editingFromSummary, setEditingFromSummary] = useState(false);
    const chatRefs = useRef({}); // Store refs for each chat item
    const [summaryEditInProgress, setSummaryEditInProgress] = useState(false);
    const DEBOUNCE_MS = 800;
    const saveTimerRef = useRef(null);
    const isSavingRef = useRef(false);
    const lastSavedSignatureRef = useRef(null);
    const hasLoadedChatRef = useRef(false);
    const isLoadingChatRef = useRef(false);

    useEffect(() => {
        // For steps 101 and 102, always scroll to show the bot question
        if (step === 101 || step === 102) {
            const currentBotMessage = chatHistory.findIndex(
                chat => chat.formStep === step && chat.type === CHAT_TYPE.BOT
            );

            if (currentBotMessage !== -1 && chatRefs.current[currentBotMessage]) {
                chatRefs.current[currentBotMessage-1].scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
                return;
            }
        }
        const prevIndex = chatHistory.length - 3;
        const prevMessageRef = chatRefs.current[prevIndex];
        if (prevMessageRef && step <= 16) {
            prevMessageRef.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        else if (newMessageRef.current) {
            newMessageRef.current.scrollIntoView({ behavior: "auto", block: "start" });
        }
    }, [chatHistory]);

    const saveChatState = useCallback(() => {
        if (!programIdState) return;

        const stateData = {
            chatHistory,
            wizard,
            step,
            programIdState,
            detectedCompetencies,
            chatInitiated,
            selectedFormats,
            selectedDeliveries,
            selectedSensitivities,
            sessionDuration,
            numSessions,
            exposureDetail,
            formatOther,
            bestDeliveryOther,
            culturalOther,
            culturalDetail,
        };

        const signature = JSON.stringify(stateData);
        if (lastSavedSignatureRef.current === signature) {
            return;
        }

        if (saveTimerRef.current) {
            clearTimeout(saveTimerRef.current);
        }

        saveTimerRef.current = setTimeout(async () => {
            if (isSavingRef.current) return;
            isSavingRef.current = true;
            try {
                await saveChatStateInsiderService(programIdState, stateData);
                lastSavedSignatureRef.current = signature;
            } catch (e) {
                console.warn('saveChatStateInsiderService failed:', e);
            } finally {
                isSavingRef.current = false;
                saveTimerRef.current = null;
            }
        }, DEBOUNCE_MS);
    }, [
        chatHistory,
        wizard,
        step,
        programIdState,
        detectedCompetencies,
        chatInitiated,
        selectedFormats,
        selectedDeliveries,
        selectedSensitivities,
        sessionDuration,
        numSessions,
        exposureDetail,
        formatOther,
        bestDeliveryOther,
        culturalOther,
        culturalDetail
    ]);

    const loadChatState = useCallback(async () => {
        if (hasLoadedChatRef.current || isLoadingChatRef.current) {
            return false;
        }
        isLoadingChatRef.current = true;
        try {
            const response = await getActiveChatInsiderProgramService();
            console.log(response);
            if (!response.data || !response.data.program_id) {
                return false;
            }
            const programId = response.data.program_id;

            const resp = await loadChatStateInsiderService(programId);

            if (resp.data) {
                const {
                    chatHistory: loadedChatHistory,
                    wizard: loadedWizard,
                    step: loadedStep,
                    detectedCompetencies: loadedCompetencies,
                    chatInitiated: loadedChatInitiated,

                    selectedFormats: loadedSelectedFormats,
                    selectedDeliveries: loadedSelectedDeliveries,
                    selectedSensitivities: loadedSelectedSensitivities,
                    sessionDuration: loadedSessionDuration,
                    numSessions: loadedNumSessions,
                    exposureDetail: loadedExposureDetail,
                    formatOther: loadedFormatOther,
                    bestDeliveryOther: loadedBestDeliveryOther,
                    culturalOther: loadedCulturalOther,
                    culturalDetail: loadedCulturalDetail,
                } = resp.data;

                // Set program ID if program is not completed
                if (loadedStep !== 17) {
                    setProgramIdState(programId);
                }

                setChatHistory(loadedChatHistory || []);
                setWizard(loadedWizard || initialState);
                setStep(loadedStep || 0);
                setDetectedCompetencies(loadedCompetencies || []);
                setChatInitiated(loadedChatInitiated || false);

                setSelectedFormats(loadedSelectedFormats || []);
                setSelectedDeliveries(loadedSelectedDeliveries || []);
                setSelectedSensitivities(loadedSelectedSensitivities || Array(SENSITIVITIES.length).fill(0));
                setSessionDuration(loadedSessionDuration || null);
                setNumSessions(loadedNumSessions || null);
                setExposureDetail(loadedExposureDetail || "");
                setFormatOther(loadedFormatOther || "");
                setBestDeliveryOther(loadedBestDeliveryOther || "");
                setCulturalOther(loadedCulturalOther || "");
                setCulturalDetail(loadedCulturalDetail || "");

                hasLoadedChatRef.current = true;
                return true;
            }
        } catch (error) {
            console.error('Error loading chat state (server):', error);
        } finally {
            isLoadingChatRef.current = false;
        }
        return false;
    }, []);

    const handleStartOver = useCallback(async () => {
        try {
            if (programIdState) {
               const response = await clearChatStateInsiderService(programIdState);
               if(response.data && response.data.success) {
                    console.log('Chat state cleared successfully', response);
                   // Reset all state
                   setChatHistory([]);
                   setWizard({...initialState, CourseCode: ''});
                   setStep(0);
                   setProgramIdState(null);
                   setDetectedCompetencies([]);
                   setChatInitiated(false);
                   setShowChat(false);
                   setInput('');
                   setIsNewProgram(true);

                   // Reset form-specific states
                   setSubjectOther(null);
                   setSessionDuration(null);
                   setNumSessions(null);
                   setExposureDetail("");
                   setFormatOther("");
                   setBestDeliveryOther("");
                   setCulturalOther("");
                   setCulturalDetail("");
                   setSelectedFormats([]);
                   setSelectedDeliveries([]);
                   setSelectedSensitivities(Array(SENSITIVITIES.length).fill(0));
                }
            }
        } catch (e) {
            console.warn('clearChatStateInsiderService failed:', e);
        }

    }, [programIdState]);

    // step 17 (final step), mark as completed
    const handleProgramCompletion = async () => {
        try {
            if (programIdState) {
                await saveChatStateInsiderService(programIdState, {
                    chatHistory,
                    wizard,
                    step: 17,
                    programIdState,
                    detectedCompetencies,
                    isCompleted: true,
                    completedAt: Date.now(),
                });
            }
        } catch (e) {
            console.warn('Final save failed:', e);
        }

        history.push({
            pathname: '/dq_pro/products/program/name',
            state: { ...wizard }
        });
    };


    // Save state whenever important changes occur
    useEffect(() => {
        if (chatInitiated && programIdState) {
            saveChatState();
        }
    }, [chatHistory, wizard, step, chatInitiated, programIdState]);

    // Load state on mount
    useEffect(() => {
        const initializeState = async () => {
            const wasRestored = await loadChatState();
            if (wasRestored) {
                // Scroll to bottom after restoration
                setTimeout(() => {
                    if (newMessageRef.current) {
                        newMessageRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 100);
            }
        };

        initializeState();
    }, []);

    useEffect(() => {
        return () => {
            if (saveTimerRef.current) {
                clearTimeout(saveTimerRef.current);
            }
        };
    }, []);

    // Helpers for chat history
    const pushUserMsg = (msg, formStep = null) =>
        setChatHistory((prev) => [...prev, { type: CHAT_TYPE.USER, text: msg, formStep }]);

    const pushBotMsg = (msg, options = {}) => {
        // Only push if message is not empty or if it has special properties like formStep
        if (msg?.trim() || options.formStep || options.renderTable) {
            setChatHistory((prev) => [
                ...prev,
                { type: CHAT_TYPE.BOT, text: msg, ...options },
            ]);
        }
    };

    const handleEditClick = (index) => {
        // console.log('index', index);
        const chatItem = chatHistory[index];
        // console.log('chatItem', chatItem);
        // console.log('chatItem.formStep', chatItem.formStep);
        if (!chatItem.formStep) return;

        setActiveEditStep(chatItem.formStep);
        setChatHistory(prev => prev.slice(0, index + 1));
        setStep(chatItem.formStep);
        addFormStep(chatItem.formStep);
    };

    const handleEditFromSummary = (formStep) => {
        setEditingFromSummary(true);

        // Check if this is a multi-step edit chain
        const isMultiStepEdit = [10, 11, 7, 4].includes(formStep); // Add 7 for structure

        if (isMultiStepEdit) {
            setSummaryEditInProgress(true);
        }

        // Find the existing chat item with this formStep
        const existingChatIndex = chatHistory.findIndex(
            chat => chat.formStep === formStep && chat.type === CHAT_TYPE.BOT
        );

        if (existingChatIndex !== -1) {
            // Scroll to the existing chat item
            setTimeout(() => {
                const chatElement = chatRefs.current[existingChatIndex-1];
                if (chatElement) {
                    chatElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);

            // Activate the existing form
            setChatHistory(prev => prev.map((chat, index) => {
                if (index === existingChatIndex) {
                    return { ...chat, isActive: true };
                }
                return { ...chat, isActive: false };
            }));

            setStep(formStep);
        }
    };

    const ensureSummaryStepInChat = () => {
        setChatHistory(prev => {
            // Remove any inactive summaries
            let filtered = prev.filter(
                chat => !(chat.formStep === 16 && !chat.isActive)
            );
            // Remove duplicate summary steps
            filtered = filtered.filter(
                (chat, idx, arr) =>
                    !(chat.formStep === 16 && arr.findIndex(c => c.formStep === 16) !== idx)
            );
            // Check if a summary already exists
            const hasSummary = filtered.some(chat => chat.formStep === 16);
            if (!hasSummary) {
                return [
                    ...filtered,
                    {
                        type: CHAT_TYPE.BOT,
                        text: "",
                        formStep: 16,
                        isActive: true,
                    },
                ];
            }
            // Make the summary active if it's there
            return filtered.map(chat =>
                chat.formStep === 16
                    ? { ...chat, isActive: true }
                    : { ...chat, isActive: false }
            );
        });
        setStep(16);
    };

    // helper function to handle returning to summary
    const returnToSummary = () => {
        setEditingFromSummary(false);

        // Deactivate all forms
        setChatHistory(prev => prev.map(chat => ({ ...chat, isActive: false })));

        // Scroll back to summary
        setTimeout(() => {
            const summaryIndex = chatHistory.findIndex(
                chat => chat.formStep === 16 && chat.type === CHAT_TYPE.BOT
            );
            if (summaryIndex !== -1) {
                const summaryElement = chatRefs.current[summaryIndex];
                if (summaryElement) {
                    summaryElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }
        }, 100);

        setStep(16);
    };

    // Add form step to chat
    const addFormStep = (stepNumber) => {
        setChatHistory((prev) => [
            ...prev,
            {
                type: CHAT_TYPE.BOT,
                text: "",
                formStep: stepNumber,
                isActive: true,
            },
        ]);
        setStep(stepNumber);
    };

    // Create a renderFormStep function
    const renderFormStep = (stepNumber) => {
        switch (stepNumber) {
            case 2:
                return renderStep2();
            case 3:
                return renderStep3();
            case 4:
                return renderStep4();
            case 5:
                return renderStep5();
            case 6:
                return renderStep6();
            case 7:
                return renderStep7();
            case 8:
                return renderStep8();
            case 81:
                return renderStep81();
            case 9:
                return renderStep9();
            case 10:
                return renderStep10();
            case 11:
                return renderStep11();
            case 12:
                return renderStep12();
            case 13:
                return renderStep13();
            case 14:
                return renderStep14();
            case 15:
                return renderStep15();
            case 16:
                return renderStep16();
            case 17:
                return renderStep17();
            case 71:
                return renderStep9(); // Custom duration input
            case 101:
                return renderStep101();
            case 102:
                return renderStep102();
            case 111:
                return renderStep111();
            case 121:
                return renderStep121();
            case 151:
                return renderStep151();
            default:
                return null;
        }
    };

    // Complete form step
    const completeFormStep = (stepNumber, userMessage) => {
        // Chain for "learningContext" summary edit: steps 11 → 111 (optional) → 15
        if (summaryEditInProgress && (stepNumber === 11 || stepNumber === 111)) {
            // Normal update logic
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));

            // Handle exposure step, which could branch to 111 or directly to 15
            if (stepNumber === 11 && (wizard.ExposureTopic === 1 || wizard.ExposureTopic === 2)) {
                // Continue to step 111
            }

            // If exposure step ends (11/111), now show sensitivities (step 15)
            if (stepNumber === 11 && wizard.ExposureTopic >= 3 || stepNumber === 111) {
                // Continue to step 15
            }
        }

        if (summaryEditInProgress && stepNumber === 15) {
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));
            setEditingFromSummary(false);
            setSummaryEditInProgress(false);
            ensureSummaryStepInChat();
            return;
        }

        // Multi-step summary edit (example: editing focus areas = steps 10, 101, 102)
        const isFocusAreaEditChain = [10, 101, 102].includes(stepNumber);

        if (summaryEditInProgress && isFocusAreaEditChain) {
            // Update chat history for edit steps
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));

            // If this is the **last step** in the edit chain, return to summary
            if (stepNumber === 102) {
                setEditingFromSummary(false);
                setSummaryEditInProgress(false);
                ensureSummaryStepInChat();
            }
            // Otherwise, continue the edit chain—do not redirect yet
            return;
        }

        // Handle structure edit chain (steps 7, 8, 81, 9)
        const isStructureEditChain = [7, 8, 81, 9].includes(stepNumber);

        if (summaryEditInProgress && isStructureEditChain) {
            // Update existing chat entries instead of adding new ones
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));

            // If this is the last step in structure edit chain, return to summary
            if ((stepNumber === 8 && wizard.StructureType === 1) ||
                (stepNumber === 9 && (wizard.StructureType === 2 || wizard.StructureType === 3))) {
                setEditingFromSummary(false);
                setSummaryEditInProgress(false);
                ensureSummaryStepInChat();
            }
            return;
        }

        if (editingFromSummary && stepNumber === 121) {
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));
            setEditingFromSummary(false);
            setSummaryEditInProgress(false);
            ensureSummaryStepInChat(); // Return to summary
            return;
        }

        if (editingFromSummary) {
            // For summary edits, update the existing user message
            setChatHistory(prev => prev.map(chat => {
                if (chat.type === CHAT_TYPE.USER && chat.formStep === stepNumber) {
                    return { ...chat, text: userMessage };
                }
                if (chat.formStep === stepNumber && chat.type === CHAT_TYPE.BOT) {
                    return { ...chat, isActive: false };
                }
                return chat;
            }));

            // Reset editing state before handling logic
            setEditingFromSummary(false);

            // Check if this step has conditional logic that leads to another step
            const hasConditionalLogic = checkForConditionalLogic(stepNumber);

            if (hasConditionalLogic) {
                handleConditionalLogic(stepNumber, userMessage);
            } else {
                returnToSummary();
            }
        } else {
            // Original logic for normal flow
            setChatHistory((prev) =>
                prev
                    .filter((msg) =>
                        !(msg.type === CHAT_TYPE.USER && msg.formStep === stepNumber)
                    )
                    .map((msg) =>
                        msg.formStep === stepNumber
                            ? { ...msg, isActive: false, userResponse: userMessage }
                            : msg
                    )
            );
            pushUserMsg(userMessage, stepNumber);
        }
    };

    // helper functions for conditional logic
    const checkForConditionalLogic = (stepNumber) => {
        // Define which steps have conditional logic
        const conditionalSteps = [7, 11, 12, 15]; // Add more as needed
        return conditionalSteps.includes(stepNumber);
    };

    const handleConditionalLogic = (stepNumber, userMessage) => {
        // Handle the specific conditional logic for each step
        switch (stepNumber) {
            case 4: // Curriculum type
                if (wizard.CurriculumType === 1) {
                    // Integrate into existing subjects - show subject area question
                    addFormStep(5);
                    setStep(5);
                } else {
                    // Standalone curriculum - go back to summary
                    returnToSummary();
                }
                break;
            case 7: // Structure type
                if (wizard.StructureType === 2 || wizard.StructureType === 3) {
                    // Multi-session logic
                    addFormStep(81);
                    setStep(81);
                } else {
                    // Single session logic
                    addFormStep(8);
                    setStep(8);
                }
                break;
            case 11: // Prior exposure
                if (wizard.ExposureTopic === 1 || wizard.ExposureTopic === 2) {
                    addFormStep(111);
                    setStep(111);
                } else {
                    returnToSummary();
                }
                break;
            // case 12: // Format selection
            //     if (wizard.Format[4] === 1) {
            //         addFormStep(121);
            //         setStep(121);
            //     } else {
            //         returnToSummary();
            //     }
            //     break;
            // Add more cases as needed
            default:
                returnToSummary();
        }
    };

    // Each form step
    const renderStep2 = () => (
        <Box className={classes.formContainer} style={{display:'flex', flexDirection:'column'}}>
            <TextField
                select
                label="Select age group"
                value={wizard.Age}
                onChange={(e) => {
                    console.log('Selected value:', e.target.value);
                    setWizard((w) => ({ ...w, Age: e.target.value }));
                }}
                variant="outlined"
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                bgcolor: '#fff',
                                border: '2px solid #FE686F',
                                mt: 0.5,
                            },
                        },
                    },
                }}
                InputProps={{
                    sx: {
                        '& fieldset': {
                            borderColor: '#FE686F',
                        },
                        '&:hover fieldset': {
                            borderColor: '#ff7a80',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#FE686F',
                            borderWidth: 2,
                        },
                    },
                }}
                InputLabelProps={{
                    sx: {
                        color: '#FE686F',
                        '&.Mui-focused': {
                            color: '#FE686F',
                            backgroundColor: '#fff',
                            px: 0.5,
                            transform: 'translate(14px, -6px) scale(0.75)',
                        },
                    },
                }}
                sx={{
                    minWidth: 220,
                    background: "#fff",
                    borderRadius: 2,
                    borderWidth: 2,
                    mb: 2,
                }}
            >
                <MenuItem value="" disabled>Select age group</MenuItem>
                {TARGET_AGE.filter(Boolean).map((age) => (
                    <MenuItem key={age.value} value={age.value}>
                        {age.label}
                    </MenuItem>
                ))}
            </TextField>

            <Button
                sx={{
                    width:'200px',
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!wizard.Age}
                onClick={() => {
                    const ageLabel =
                        TARGET_AGE.find((a) => a.value === wizard.Age)?.label ||
                        wizard.Age;
                    completeFormStep(2, ageLabel);
                    if (editingFromSummary) {
                        ensureSummaryStepInChat();
                        return;
                    }
                    pushBotMsg("Please select the country for your program.");
                    addFormStep(3); // Remove the function call parameter
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    const renderStep3 = () => (
        <Box className={classes.formContainer}>
            <TextField
                select
                label="Select country"
                value={wizard.Countries}
                onChange={(e) =>
                    setWizard((w) => ({ ...w, Countries: e.target.value }))
                }
                variant="outlined"
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                bgcolor: '#fff',
                                border: '2px solid #FE686F',
                                mt: 0.5,
                            },
                        },
                    },
                }}
                InputProps={{
                    sx: {
                        '& fieldset': {
                            borderColor: '#FE686F',
                        },
                        '&:hover fieldset': {
                            borderColor: '#ff7a80',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#FE686F',
                            borderWidth: 2,
                        },
                    },
                }}
                InputLabelProps={{
                    sx: {
                        color: '#FE686F',
                        '&.Mui-focused': {
                            color: '#FE686F',
                            backgroundColor: '#fff',
                            px: 0.5,
                            transform: 'translate(14px, -6px) scale(0.75)',
                        },
                    },
                }}
                sx={{
                    minWidth: 220,
                    background: "#fff",
                    borderRadius: 2,
                    borderWidth: 2,
                    mb: 2,
                }}
            >
                    <MenuItem value="" disabled>Select country</MenuItem>
                {REGIONS.map((region) => (
                    <MenuItem key={region.value} value={region.value}>
                        {region.label}
                    </MenuItem>
                ))}
            </TextField>
            <Button
                sx={{
                    width:'200px',
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!wizard.Countries}
                onClick={() => {
                    const countryLabel =
                        REGIONS.find((r) => r.value === wizard.Countries)
                            ?.label || wizard.Countries;
                    completeFormStep(3, countryLabel);
                    if (editingFromSummary) {
                        ensureSummaryStepInChat();
                        return;
                    }
                    pushBotMsg(
                        "How would you like to implement this AI Literacy program?"
                    );
                    addFormStep(4, renderStep4());
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    const renderStep4 = () => (
        <Box className={classes.formContainer} style={{display:'flex', flexDirection:'column'}}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap:{xs:'wrap', md:'nowrap'}, justifyContent: 'center', mb: 4 }}>
            <Button
                fullWidth
                sx={{
                    background:
                        wizard.CurriculumType === 1 ? "#FE686F" : "#fff",
                    color: wizard.CurriculumType === 1 ? "#fff" : "#FE686F",
                    border: wizard.CurriculumType === 1 ? "none" : "2px solid #FE686F",
                    borderRadius: "16px",
                    py: 2,
                    px: 2,
                    mb: 2,
                    fontSize: 14,
                    fontWeight: 700,
                    "&:hover": { background: "#FE686F", color:"#fff" },
                }}
                onClick={() => {
                    setWizard((w) => ({ ...w, CurriculumType: 1 }));
                }}
            >
                Integrate into existing subjects (e.g., Math, English, Science)
            </Button>
            <Button
                fullWidth
                sx={{
                    background:
                        wizard.CurriculumType === 2 ? "#FE686F" : "#fff",
                    color: wizard.CurriculumType === 2 ? "#fff" : "#FE686F",
                    border: wizard.CurriculumType === 2 ? "none" : "2px solid #FE686F",
                    borderRadius: "16px",
                    py: 2,
                    px: 2,
                    mb: 2,
                    fontSize: 14,
                    fontWeight: 700,
                    "&:hover": { background: "#FE686F", color:"#fff" },
                }}
                onClick={() => {
                    setWizard((w) => ({ ...w, CurriculumType: 2 }));
                }}
            >
                Develop as a standalone AI Literacy curriculum
            </Button>
            </Box>
            <Button
                sx={{
                    width:'200px',
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!wizard.CurriculumType}
                onClick={() => {
                    let label =
                        wizard.CurriculumType === 1
                            ? "Integrate into existing subjects (e.g., Math, English, Science)"
                            : "Develop as a standalone AI Literacy curriculum";
                    completeFormStep(4, label);

                    if (wizard.CurriculumType === 1) {
                        pushBotMsg(
                            "Which subject area should this program be connected to?"
                        );
                        addFormStep(5, renderStep5);
                    } else {
                        setWizard((w) => ({ ...w, SubjectArea: null, SubjectAreaOther: null, SubjectContextTopic: '' })); // Clear if switching to standalone
                        if (editingFromSummary) {
                            // Will be handled by completeFormStep
                            ensureSummaryStepInChat();
                            return;
                        }
                        // Skip subject area, go to next step directly
                        pushBotMsg("How should the program be structured?")
                        addFormStep(7, renderStep7);
                    }
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    const renderStep5 = () => (
        <Box className={classes.formContainer}>
            <TextField
                select
                label="Select subject"
                value={wizard.SubjectArea || ""}
                onChange={(e) =>
                    setWizard((w) => ({ ...w, SubjectArea: parseInt(e.target.value, 10) }))
                }
                variant="outlined"
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                bgcolor: '#fff',
                                border: '2px solid #FE686F',
                                mt: 0.5,
                            },
                        },
                    },
                }}
                InputProps={{
                    sx: {
                        '& fieldset': {
                            borderColor: '#FE686F',
                        },
                        '&:hover fieldset': {
                            borderColor: '#ff7a80',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#FE686F',
                            borderWidth: 2,
                        },
                    },
                }}
                InputLabelProps={{
                    sx: {
                        color: '#FE686F',
                        '&.Mui-focused': {
                            color: '#FE686F',
                            backgroundColor: '#fff',
                            px: 0.5,
                            transform: 'translate(14px, -6px) scale(0.75)',
                        },
                    },
                }}
                sx={{
                    minWidth: 220,
                    background: "#fff",
                    borderRadius: 2,
                    borderWidth: 2,
                    mb: 2,
                }}
            >
                <MenuItem value="" disabled> Select subject</MenuItem>
                {SUBJECTS.map((sub) => (
                    <MenuItem  key={sub.value} value={sub.value}>
                        {sub.label}
                    </MenuItem>
                ))}
                {/*<MenuItem value={11}>Other</MenuItem>*/}
            </TextField>
            {wizard.SubjectArea === 10 && (
                <TextField
                    sx={{ mb: 2, mt: 1 }}
                    fullWidth
                    variant="outlined"
                    placeholder="Please specify other subject"
                    value={subjectOther}
                    onChange={(e) => setSubjectOther(e.target.value)}
                />
            )}
            <Button
                sx={{
                    width:'200px',
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={
                    !wizard.SubjectArea ||
                    (wizard.SubjectArea === 10 && !subjectOther)
                }
                onClick={() => {
                    const selectedSubject =
                        wizard.SubjectArea === 10
                            ? subjectOther
                            : SUBJECTS.find((s) => s.value === wizard.SubjectArea)?.label;
                    setWizard((w) => ({
                        ...w,
                        SubjectAreaOther:
                            wizard.SubjectArea === 10 ? subjectOther : null,
                    }));
                    completeFormStep(5, selectedSubject);
                    pushBotMsg(
                        "To support subject integration, could you specify a background learning topic from your selected subject(s) that could provide a relevant context for teaching Al Literacy?\n" +
                        "\n" +
                        "For example:\n" +
                        "“I’m teaching data interpretation in Mathematics and want to integrate the topic of disinformation,”\n" +
                        "or\n" +
                        "“I’m covering essay writing in English and want to explore the issue of Al misuse in academic cheating.”\n" +
                        "Please describe the learning topic or unit where Al Literacy would be most relevant."
                    );
                    addFormStep(6, renderStep6());
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    const renderStep6 = () => (
        <Box className={classes.formContainer} sx={{width:'100%'}}>
            <TextField
                fullWidth
                multiline="true"
                variant="outlined"
                label="Describe the learning unit or topic..."
                value={wizard?.SubjectContextTopic || ""}
                sx={{mb: 1,}}
                onChange={(e) => {
                    const value = e.target.value;
                    setWizard(prevWizard => ({
                        ...prevWizard,
                        SubjectContextTopic: value
                    }));
                }}
            />
            <Button
                sx={{
                    width:'200px',
                    mx:'auto',
                    mt: 3,
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!wizard.SubjectContextTopic?.trim()}
                onClick={() => {
                    completeFormStep(6, wizard.SubjectContextTopic);
                    if (summaryEditInProgress || editingFromSummary) {
                        setEditingFromSummary(false);
                        setSummaryEditInProgress(false);
                        ensureSummaryStepInChat(); // Go back to summary after editing!
                        return;
                    }
                    pushBotMsg("How should the program be structured?");
                    addFormStep(7, renderStep7());
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    const renderStep7 = () => (
        <Box className={classes.formContainer} sx={{width:'100%'}}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap:{xs:'wrap', md: 'nowrap'},justifyContent: 'center', mb: 2, }}>
            <Button
                fullWidth
                sx={{
                    width: 200,
                    minHeight: 120,
                    background: wizard.StructureType === 1 ? "#FE686F" : "#fff",
                    color: wizard.StructureType === 1 ? "#fff" : "#FE686F",
                    border: wizard.StructureType === 1 ? "none" : "2px solid #FE686F",
                    borderRadius: "16px",
                    py: 2,
                    px: 2,
                    mb: 2,
                    fontSize: 14,
                    fontWeight: 700,
                    "&:hover": { background: "#FE686F", color:"#fff" },
                }}
                onClick={() => {
                    setWizard((w) => ({ ...w, StructureType: 1 }));
                }}
            >
                A single-session program
            </Button>
            <Button
                fullWidth
                sx={{
                    width: 200,
                    minHeight: 120,
                    background: wizard.StructureType === 2 ? "#FE686F" : "#fff",
                    color: wizard.StructureType === 2 ? "#fff" : "#FE686F",
                    border: wizard.StructureType === 2 ? "none" : "2px solid #FE686F",
                    borderRadius: "16px",
                    py: 2,
                    px: 2,
                    mb: 2,
                    fontSize: 14,
                    fontWeight: 700,
                    "&:hover": { background: "#FE686F", color:"#fff" },
                }}
                onClick={() => {
                    setWizard((w) => ({ ...w, StructureType: 2 }));
                }}
            >
                A multi-session course
            </Button>
            {/*<Button*/}
            {/*    fullWidth*/}
            {/*    sx={{*/}
            {/*        width: 200,*/}
            {/*        minHeight: 120,*/}
            {/*        background: wizard.StructureType === 3 ? "#FE686F" : "#fff",*/}
            {/*        color: wizard.StructureType === 3 ? "#fff" : "#FE686F",*/}
            {/*        border: wizard.StructureType === 3 ? "none" : "2px solid #FE686F",*/}
            {/*        borderRadius: "16px",*/}
            {/*        py: 2,*/}
            {/*        px: 2,*/}
            {/*        mb: 2,*/}
            {/*        fontSize: 14,*/}
            {/*        fontWeight: 700,*/}
            {/*        "&:hover": { background: "#FE686F", color:"#fff" },*/}
            {/*    }}*/}
            {/*    onClick={() => {*/}
            {/*        setWizard((w) => ({ ...w, StructureType: 3 }));*/}
            {/*    }}*/}
            {/*>*/}
            {/*    I’m not sure—please suggest a structure*/}
            {/*</Button>*/}
            </Box>
            <Button
                sx={{
                    width: '200px',
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!wizard.StructureType}
                onClick={() => {
                    let label =
                        wizard.StructureType === 1
                            ? "A single-session program"
                            : wizard.StructureType === 2
                                ? "A multi-session course"
                                : "I’m not sure—please suggest a structure";
                    if (wizard.StructureType === 2 || wizard.StructureType === 3) {
                        completeFormStep(7, label);
                        if (!editingFromSummary) {
                            pushBotMsg("How many sessions would you like for your multi-session course?");
                        }
                        addFormStep(81); // New step for session count
                    } else {
                        setWizard((w) => ({ ...w, NumSessions: 1 })); // Default to 1 session for single-session programs
                        setNumSessions(1);
                        completeFormStep(7, label);
                        if (!editingFromSummary) {
                            pushBotMsg("Please specify the session duration.");
                        }
                        addFormStep(8);
                    }
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // Updated renderSessionDurationStep function
    const renderStep8 = () => (
        <Box className={classes.formContainer} sx={{width:'unset', height:'auto'}}>
            {/*<Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>*/}
            {/*    How long would you like the session to be?*/}
            {/*    <br />*/}
                <Typography variant="body2" sx={{ color: '#666', mb:3, }}>
                    This will help us plan the content depth and pacing appropriately.
                </Typography>
            {/*</Typography>*/}

            <Box sx={{ display: 'flex', gap: 2,flexWrap:{xs:'wrap', md:'nowrap'}, justifyContent: {xs:'flex-start', md:'center'}, mb: 4 }}>
            {/* Pill buttons exactly like your screenshot */}
            {[
                { label: 'Less than 30 minutes', val: 25 },
                { label: '30 minutes', val: 30 },
                { label: '45 minutes', val: 45 },
                { label: '1 hour', val: 60 },
                // { label: 'Other', val: 'other' },
            ].map(({ label, val }) => (
                <Button
                    sx={{width:{xs:'125px', md:'200px'}, minHeight: 120,
                    ...pillButtonSx(sessionDuration === val)
                    }}
                    key={val}
                    fullWidth
                    onClick={() => {
                        if (val === 'other') {
                            setSessionDuration(null); // Reset for custom input
                            // You'll need to add a state to track if "Other" is selected
                            // or modify your step logic to handle this
                            setStep(9); // Special step for "Other" input
                        } else {
                            setSessionDuration(val);
                            setWizard(w => ({ ...w, SessionDuration: val }));
                            const totalDuration = val * (wizard.NumSessions || 1);
                            setWizard(w => ({ ...w, SuggestApproxHours: totalDuration }));
                            completeFormStep(8, `${val} minutes`);
                            if (summaryEditInProgress || editingFromSummary) {
                                setEditingFromSummary(false);
                                setSummaryEditInProgress(false);
                                ensureSummaryStepInChat(); // Go back to summary after editing!
                                return;
                            }
                            // Continue to next step...
                            pushBotMsg(  `Thank you! To tailor the program to your learning priorities, please rate the importance of each of the following focus areas. <strong>You must select at least one to be Very Important.</strong>`);
                            addFormStep(10); // Assuming step 8 is next
                        }
                    }}
                >
                    {label}
                </Button>
            ))}
            </Box>
        </Box>
    );

    const renderStep81 = () => (
        <Box className={classes.formContainer} style={{height:'auto', width:'unset'}}>
            {/*<Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>*/}
            {/*    How many sessions would you like for your multi-session course?*/}
            {/*</Typography>*/}

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(sessionCount => (
                    <Button
                        sx={{width:{xs:'130px', md:'15%'}, height:'100px',border:'2px solid #FE686F',
                        ...pillButtonSx(numSessions === sessionCount)
                    }}
                        key={sessionCount}

                        onClick={() => setNumSessions(sessionCount)}
                    >
                        {sessionCount} {sessionCount === 1 ? 'Session' : 'Sessions'}
                    </Button>
                ))}
            </Box>

            <Button
                sx={{
                    width:{xs:'200px'},
                    mx:'auto',
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    }
                }}
                disabled={!numSessions}
                onClick={() => {
                    setWizard(w => ({ ...w, NumSessions: numSessions }));
                    completeFormStep(81, `${numSessions} ${numSessions === 1 ? 'session' : 'sessions'}`);
                    pushBotMsg("Please specify the duration for each session.");
                    addFormStep(8);
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // Add a new render function for the custom duration input (step 71)
    const renderStep9 = () => (
        <Box className={classes.formContainer}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Please tell us the duration in minutes:
            </Typography>

            {/* Chat-style input box */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    background: '#fff',
                    borderRadius: '30px',
                    border: '2px solid #ff7043',
                    p: '5px 15px',
                    width: '100%'
                }}
            >
                <TextField
                    value={sessionDuration}
                    onChange={e => setSessionDuration(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && sessionDuration?.trim()) {
                            const min = Number(sessionDuration);
                            if (isNaN(min) || min <= 0) return;
                            setWizard(w => ({ ...w, SessionDuration: min }));
                            completeFormStep(9, `${min} minutes`);
                            // Continue to next step...
                            pushBotMsg(`Thank you! To tailor the program to your learning priorities, please rate the importance of each of the following focus areas. <strong>You must select at least one to be Very Important.</strong>`);
                            addFormStep(10); // Assuming step 8 is next
                        }
                    }}
                    placeholder="Type the exact minutes..."
                    variant="standard"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                />
                <IconButton
                    onClick={() => {
                        const min = Number(sessionDuration);
                        if (isNaN(min) || min <= 0) return;
                        setWizard(w => ({ ...w, SessionDuration: min }));
                        const totalDuration = min * (wizard.NumSessions || 1);
                        setWizard(w => ({ ...w, SuggestApproxHours: totalDuration }));
                        completeFormStep(9, `${min} minutes`);
                        if (summaryEditInProgress || editingFromSummary) {
                            setEditingFromSummary(false);
                            setSummaryEditInProgress(false);
                            ensureSummaryStepInChat();
                            return;
                        }
                        // Continue to next step...
                        pushBotMsg(`Thank you! To tailor the program to your learning priorities, please rate the importance of each of the following focus areas. <strong>You must select at least one to be Very Important.</strong>`);
                        addFormStep(10); // Assuming step 8 is next
                    }}
                    disabled={!sessionDuration?.trim() || isNaN(Number(sessionDuration)) || Number(sessionDuration) <= 0}
                    sx={{
                        background: (sessionDuration?.trim() && !isNaN(Number(sessionDuration)) && Number(sessionDuration) > 0) ? '#FE686F' : '#e0e0e0',
                        color: 'white',
                        '&:hover': {
                            background: (sessionDuration?.trim() && !isNaN(Number(sessionDuration)) && Number(sessionDuration) > 0) ? '#ff7a80' : '#e0e0e0',
                        }
                    }}
                >
                    <ArrowUpward />
                </IconButton>
            </Box>
        </Box>
    );

    // --- STEP 10 ---
    const renderStep10 = () => (
        <Box sx={{ mt: 2,display:'flex', flexDirection:'column',width:'100%' }}>
            {/*<Typography variant="h6" sx={{ mb: 1 }}>*/}
            {/*    Thank you! To tailor the program to your learning priorities, please rate the importance of each of the following focus areas.*/}
            {/*</Typography>*/}
            {[
                { key: 'FocusProblem', label: 'Understanding the problems and issues related to the topic' },
                { key: 'FocusSolution', label: 'Exploring responses and solutions' },
                { key: 'FocusMindset', label: 'Encouraging a positive mindset' },
            ].map(item => (
                <Box key={item.key} sx={{ mb: 3 }}>
                    <Typography sx={{ mb: 1, fontWeight: 600 }}>• {item.label}</Typography>
                    <Box sx={{ display: 'flex', flexWrap:{xs:'wrap', md:'nowrap'}, gap: 1, }}>
                        {['Not Important At All', 'Important', 'Very Important'].map((label, idx) => {
                            const val = idx + 1;
                            return (
                                <Button
                                    sx={{width: {xs:'125px', md:'200px'}, height: {xs:'110px', md:'50px'}, border:'2px solid #FE686F',
                                        ...pillButtonSx(wizard[item.key] === val)
                                        }}
                                    key={val}
                                    fullWidth
                                    onClick={() => setWizard(w => ({ ...w, [item.key]: val }))}
                                >
                                    {label}
                                </Button>
                            );
                        })}
                    </Box>
                </Box>
            ))}
            {/*<Typography sx={{ mb: 3 }}>• Encouraging a positive mindset</Typography>*/}
            {/*<Box sx={{ display: 'flex', gap: 1 }}>*/}
            {/*    {['Not Important At All', 'Important', 'Very Important'].map((label, idx) => {*/}
            {/*        const val = idx + 1;*/}
            {/*        return (*/}
            {/*            <Button*/}
            {/*                key={val}*/}
            {/*                fullWidth*/}
            {/*                sx={pillButtonSx(wizard.FocusMindset === val)}*/}
            {/*                onClick={() => setWizard(w => ({ ...w, FocusMindset: val }))}*/}
            {/*            >*/}
            {/*                {label}*/}
            {/*            </Button>*/}
            {/*        );*/}
            {/*    })}*/}
            {/*</Box>*/}
            <Button
                sx={{
                    width: {xs:'200px'},
                    borderRadius:'20px',
                    fontSize: '14px',
                    marginRight:'auto',
                    marginLeft:{xs:'auto',md:'unset'},
                    background: "#FE686F",
                    color: "white",
                    padding: "12px 24px !important",
                    fontWeight: "bold",
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
                    textTransform: 'uppercase',
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": { background: "#ff7a80" },
                    ...pillButtonSx(true)
                }}
                disabled={
                    !wizard.FocusProblem ||
                    !wizard.FocusSolution ||
                    !wizard.FocusMindset ||
                    // Ensure at least one "Very Important" (value 3) is selected
                    ![wizard.FocusProblem, wizard.FocusSolution, wizard.FocusMindset].includes(3)
                }
                onClick={() => {
                    // Summary string for chat
                    const summary = [
                        `Problem: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusProblem-1]}`,
                        `Solution: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusSolution-1]}`,
                        `Mindset: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusMindset-1]}`
                    ].join(', ');
                    completeFormStep(10, summary);
                    if (!summaryEditInProgress) {
                        pushBotMsg(`Could you clarify which outcomes matter most? Please rate the importance of each of the following focus areas. <strong>You must select at least one to be Very Important.</strong>`);
                    }
                    addFormStep(101);
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 101 ---
    const renderStep101 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column',width:'100%'}}>
            {/*<Typography variant="h6" sx={{ mb: 2 }}>*/}
            {/*    Could you clarify which outcomes matter most? Please rate the importance of each of the following focus areas.*/}
            {/*</Typography>*/}
            {[
                { key: 'FocusKS_F', label: 'Raising awareness and acquiring factual knowledge' },
                { key: 'FocusKS_C', label: 'Gaining conceptual understanding' },
                { key: 'FocusKS_P', label: 'Developing practical and procedural skills' },
                { key: 'FocusKS_M', label: 'Building metacognitive and higher-order thinking skills' },
            ].map(item => (
                <Box key={item.key} sx={{ mb: 3 }}>
                    <Typography sx={{ mb: 1, fontWeight: 600 }}>• {item.label}</Typography>
                    <Box sx={{ display: 'flex',flexWrap:{xs:'wrap', md:'nowrap'}, gap: 1, }}>
                        {['Not Important At All', 'Important', 'Very Important'].map((label, idx) => {
                            const val = idx + 1;
                            return (
                                <Button
                                   sx={{ width: {xs:'125px', md:'200px'}, height: {xs:'110px', md:'50px'}, border:'2px solid #FE686F',
                                   ...pillButtonSx(wizard[item.key] === val),
                                   }}
                                    key={val}
                                    fullWidth
                                    onClick={() => setWizard(w => ({ ...w, [item.key]: val }))}
                                >
                                    {label}
                                </Button>
                            );
                        })}
                    </Box>
                </Box>
            ))}
            <Button
                sx={{width:{xs:'200px'}, borderRadius:'20px',  padding: "12px 24px !important", marginRight:'auto',marginLeft:{xs:'auto',md:'unset'},
                     "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    },
                    ...pillButtonSx(true)
                }}
                disabled={
                    !wizard.FocusKS_F ||
                    !wizard.FocusKS_C ||
                    !wizard.FocusKS_P ||
                    !wizard.FocusKS_M ||
                    // Ensure at least one "Very Important" (value 3) is selected
                    ![wizard.FocusKS_F, wizard.FocusKS_C, wizard.FocusKS_P, wizard.FocusKS_M].includes(3)
                }
                onClick={() => {
                    const summary = [
                        `Raising awareness and acquiring factual knowledge: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusKS_F-1]}`,
                        `Gaining conceptual understanding: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusKS_C-1]}`,
                        `Developing practical and procedural skills: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusKS_P-1]}`,
                        `Building metacognitive and higher-order thinking skills: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusKS_M-1]}`
                    ].join(', ');
                    completeFormStep(101, summary);
                    if (!summaryEditInProgress) {
                        pushBotMsg(`Moreover, please specify which mindset areas you want to emphasize. Please rate the importance of each of the following focus areas. <strong>You must select at least one to be Very Important.</strong>`);
                    }
                    addFormStep(102);
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 102 ---
    const renderStep102 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column',width:'100%'}}>
            {/*<Typography variant="h6" sx={{ mb: 2 }}>*/}
            {/*    Moreover, please specify which mindset areas you want to emphasize. Please rate the importance of each of the following focus areas.*/}
            {/*</Typography>*/}
            {[
                { key: 'FocusAB_A', label: 'Shaping positive attitudes' },
                { key: 'FocusAB_P', label: 'Strengthening values and beliefs' },
                { key: 'FocusAB_I', label: 'Discovering learners’ intentions and willingness to change' },
                { key: 'FocusAB_B', label: 'Encouraging self-reflection and behavioral habits' },
            ].map(item => (
                <Box key={item.key} sx={{ mb: 3 }}>
                    <Typography sx={{ mb: 1, fontWeight: 600 }}>• {item.label}</Typography>
                    <Box sx={{ display: 'flex', flexWrap:{xs:'wrap', md: 'nowrap'}, gap: 1, }}>
                        {['Not Important At All', 'Important', 'Very Important'].map((label, idx) => {
                            const val = idx + 1;
                            return (
                                <Button
                                    sx={{width: {xs:'125px', md:'200px'}, height: {xs:'110px', md:'50px'}, border:'2px solid #FE686F',
                                      ...pillButtonSx(wizard[item.key] === val)
                                    }}
                                    key={val}
                                    fullWidth
                                    onClick={() => setWizard(w => ({ ...w, [item.key]: val }))}
                                >
                                    {label}
                                </Button>
                            );
                        })}
                    </Box>
                </Box>
            ))}
            <Button
                sx={{width:{xs:'200px'},borderRadius:'20px',  padding: "12px 24px !important", marginRight:'auto',marginLeft:{xs:'auto',md:'unset'},
                    "&:disabled": {
                        background: "#f5b1b4",
                        color: "#fff",
                    },
                    ...pillButtonSx(true)
            }}
                disabled={
                    !wizard.FocusAB_A ||
                    !wizard.FocusAB_P ||
                    !wizard.FocusAB_I ||
                    !wizard.FocusAB_B ||
                    // Ensure at least one "Very Important" (value 3) is selected
                    ![wizard.FocusAB_A, wizard.FocusAB_P, wizard.FocusAB_I, wizard.FocusAB_B].includes(3)
                }
                onClick={() => {
                    const summary = [
                        `Shaping positive attitudes: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusAB_A-1]}`,
                        `Strengthening values and beliefs: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusAB_P-1]}`,
                        `Discovering learners’ intentions and willingness to change: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusAB_I-1]}`,
                        `Encouraging self-reflection and behavioral habits: ${['Not Important At All', 'Important', 'Very Important'][wizard.FocusAB_B-1]}`
                    ].join(', ');
                    completeFormStep(102, summary);
                    if(!editingFromSummary) {
                        pushBotMsg('To ensure we pitch the content at the right level, have your learners had prior exposure to this topic?');
                        addFormStep(11);
                    }
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 11 ---
    const renderStep11 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column',width:'100%'}}>
            {/*<Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>*/}
            {/*    To ensure we pitch the content at the right level, have your learners had prior exposure to this topic?*/}
            {/*</Typography>*/}
            <Box sx={{ display: 'flex', gap: 2, flexWrap:{xs:'wrap', md:'nowrap'},justifyContent: 'center', mb: 4 }}>
            {[
                { label: 'No prior exposure',       val: 1, desc: '' },
                { label: 'Some informal exposure',  val: 2, desc: '(e.g., social-media, peer discussions)' },
                { label: 'Formal exposure',         val: 3, desc: '(e.g., classroom learning)' },
                { label: 'Uncertain',               val: 4, desc: '' },
            ].map(({ label, val, desc }) => (
                <Button
                    sx={{display:'flex',flexDirection:'column', width:{xs:'200px', md:'30%'}, minHeight: {xs:'auto', md:'120px'}, border:'2px solid #FE686F',
                    ...pillButtonSx(wizard.ExposureTopic === val)
                }}
                    key={val}
                    fullWidth
                    onClick={() => {
                        setWizard(w => ({ ...w, ExposureTopic: val }));
                        setWizard(w => ({ ...w, ExposureTopicDetail: null }));
                        completeFormStep(11, label);
                        if (summaryEditInProgress) {
                            if (val === 2 || val === 3) {
                                // Go to 111 (exposure detail), then 15, then summary
                                pushBotMsg("That's helpful! Could you briefly describe what your learners have already encountered?");
                                addFormStep(111);
                            } else {
                                // Skip directly to sensitivities (step 15)
                                pushBotMsg("Are there any cultural/social sensitivities to consider?");
                                addFormStep(15);
                            }
                            return; // Don’t continue normal workflow!
                        }
                        if (val === 2 || val === 3) {
                            pushBotMsg("That's helpful! Could you briefly describe what your learners have already encountered?");
                            addFormStep(111);
                        } else {
                            pushBotMsg('How would you like the learning experience to be delivered? Please select all formats that best match your goals:');
                            addFormStep(12);
                        }
                    }}
                >
                    {label}{desc && <Typography variant="caption" display="block">{desc}</Typography>}
                </Button>
            ))}
            </Box>
        </Box>
    );

    // --- STEP 111 ---
    const renderStep111 = () => (
        <Box sx={{ mt: 2,width:'100%' }}>
            {/*<Typography variant="body1" sx={{ mb: 1 }}>*/}
            {/*    Could you briefly describe what your learners have already encountered?*/}
            {/*    <br />*/}
                <Typography variant="caption" color="text.secondary">
                    (e.g., key concepts, formats used, depth of discussion)
                </Typography>
            {/*</Typography>*/}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    background: '#fff',
                    border: '2px solid #ff7043',
                    borderRadius: '30px',
                    p: '5px 15px',
                    mt: 2,
                }}
            >
                <TextField
                    value={exposureDetail}
                    onChange={e => setExposureDetail(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && exposureDetail.trim()) {
                            setWizard(w => ({ ...w, ExposureTopicDetail: exposureDetail }));
                            completeFormStep(111, exposureDetail);
                            pushBotMsg('How would you like the learning experience to be delivered? Please select all formats that best match your goals:');
                            addFormStep(12);
                        }
                    }}
                    placeholder="Type your message…"
                    variant="standard"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                />
                <IconButton
                    onClick={() => {
                        if (exposureDetail.trim()) {
                            setWizard(w => ({ ...w, ExposureTopicDetail: exposureDetail }));
                            completeFormStep(111, exposureDetail);
                            if (summaryEditInProgress) {
                                // Go to step 15
                                addFormStep(15);
                                return;
                            }
                            pushBotMsg('How would you like the learning experience to be delivered? Please select all formats that best match your goals:');
                            addFormStep(12);
                        }
                    }}
                    disabled={!exposureDetail.trim()}
                    sx={{
                        background: exposureDetail.trim() ? '#FE686F' : '#e0e0e0',
                        color: 'white',
                    }}
                >
                    <ArrowUpward />
                </IconButton>
            </Box>
        </Box>
    );

    // --- STEP 12 ---
    const renderStep12 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column'}}>
            {/*<Typography variant="h6" sx={{ mb: 2 }}>*/}
            {/*    How would you like the learning experience to be delivered? Please select all formats that best match your goals:*/}
            {/*</Typography>*/}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: {xs:'center', md:'flex-start'}, gap: 2 }}>
                {DELIVERY_FORMATS.map((format, idx) => (
                    <Button
                        sx={{
                            width:{xs:'200px', md:'200px'}, minHeight: {xs:'auto', md:'150px'},
                            border: '2px solid #FE686F',
                            ...pillButtonSx(wizard.Format[idx] === 1)
                        }}
                        key={idx}
                        fullWidth
                        // sx={pillButtonSx(wizard.Format[idx] === 1)}
                        onClick={() => {
                            setWizard(w => {
                                // Toggle between 0 and 1 at index idx
                                const updatedFormat = [...w.Format];
                                updatedFormat[idx] = updatedFormat[idx] === 1 ? 0 : 1;
                                return { ...w, Format: updatedFormat };
                            });
                        }}
                    >
                        {format.label}
                    </Button>
                ))}
            </Box>
            {/*{wizard.Format[4] === 1 && (*/}
            {/*    <TextField*/}
            {/*        fullWidth*/}
            {/*        variant="outlined"*/}
            {/*        placeholder="Please describe 'Other' format"*/}
            {/*        value={formatOther}*/}
            {/*        onChange={e => setFormatOther(e.target.value)}*/}
            {/*        sx={{ mt: 2 }}*/}
            {/*    />*/}
            {/*)}*/}
            <Button
                sx={{width:{xs:'200px'}, borderRadius:'20px', padding: "12px 24px !important", marginLeft:'auto',marginRight: 'auto',
                    ...pillButtonSx(true)
                }}
                disabled={wizard.Format.every(f => f === 0)}
                onClick={() => {
                    // Prepare chat text
                    const labels = wizard.Format
                        .map((selected, i) => selected ? DELIVERY_FORMATS[i].label : null)
                        .filter(Boolean)
                        .concat(wizard.Format[4] === 1 ? [formatOther] : []);
                    completeFormStep(12, labels.join(', '));
                    if (wizard.Format[4] === 1) {
                        pushBotMsg('Please describe any additional formats or preferences.');
                        addFormStep(121);
                    } else {
                        if (editingFromSummary || summaryEditInProgress) {
                            setEditingFromSummary(false);
                            setSummaryEditInProgress(false);
                            ensureSummaryStepInChat(); // show summary as active
                            return;
                        }
                        pushBotMsg("What kind of tech environment will your learners have during the sessions?");
                        addFormStep(13);
                    }
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 121 ---
    const renderStep121 = () => (
        <Box sx={{ mt: 2 }}>
            {/*<Typography sx={{ mb: 1 }}>*/}
            {/*    Please describe any additional formats or preferences.*/}
            {/*</Typography>*/}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    background: '#fff',
                    border: '2px solid #ff7043',
                    borderRadius: '30px',
                    p: '5px 15px',
                    width: '100%'
                }}
            >
                <TextField
                    value={formatOther}
                    onChange={e => setFormatOther(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && formatOther.trim()) {
                            setWizard(w => ({ ...w, FormatOther: formatOther }));
                            completeFormStep(121, formatOther);
                            if (editingFromSummary || summaryEditInProgress) {
                                setEditingFromSummary(false);
                                setSummaryEditInProgress(false);
                                ensureSummaryStepInChat(); // show summary as active
                                return;
                            }
                            pushBotMsg("What kind of tech environment will your learners have during the sessions?");
                            addFormStep(13);
                        }
                    }}
                    placeholder="Type your message…"
                    variant="standard"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                />
                <IconButton
                    onClick={() => {
                        setWizard(w => ({ ...w, FormatOther: formatOther }));
                        completeFormStep(121, formatOther);
                        if (editingFromSummary || summaryEditInProgress) {
                            setEditingFromSummary(false);
                            setSummaryEditInProgress(false);
                            ensureSummaryStepInChat(); // show summary as active
                            return;
                        }
                        pushBotMsg("What kind of tech environment will your learners have during the sessions?");
                        addFormStep(13);
                    }}
                    disabled={!formatOther.trim()}
                    sx={{
                        background: formatOther.trim() ? '#FE686F' : '#e0e0e0',
                        color: 'white'
                    }}
                >
                    <ArrowUpward />
                </IconButton>
            </Box>
        </Box>
    );

    // --- STEP 13 ---
    const renderStep13 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column',width:'100%' }}>
            {/*<Typography variant="h6" sx={{ mb: 2 }}>*/}
            {/*    What kind of tech environment will your learners have during the sessions?*/}
            {/*</Typography>*/}
            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                Select one option that fits to your class tech environment:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: {xs:'center',md:'flex-start'}, gap: 2 }}>
                {TECH_ENVIRONMENTS.map(env => (
                    <Button
                        sx={{width:{xs:'100%', md:'215px'}, minHeight:'180px', border:'2px solid #FE686F',mb:2,
                        ...pillButtonSx(wizard.TechEnvironment === env.value)}}
                        key={env.value}
                        fullWidth
                        onClick={() => setWizard(w => ({ ...w, TechEnvironment: env.value }))}
                    >
                        {env.label}
                    </Button>
                ))}
            </Box>
            <Button
                sx={{width:{xs:'200px'}, padding: "12px 24px !important", borderRadius:'20px', marginLeft:'auto', marginRight:'auto',
                ...pillButtonSx(true)}}
                disabled={!wizard.TechEnvironment}
                onClick={() => {
                    completeFormStep(13, `Tech Environment: ${TECH_ENVIRONMENTS.find(env => env.value === wizard.TechEnvironment)?.label}`);
                    pushBotMsg("Select up to three preferred teaching methods:");
                    addFormStep(14);
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 14 ---
    const renderStep14 = () => (
        <Box sx={{ mt: 2, display:'flex', flexDirection:'column' }}>
            {/*<Typography sx={{ mb: 2 }}>Select up to three preferred teaching methods:</Typography>*/}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: {xs:'center',md:'flex-start'}, gap: 2 }}>
            {TEACHING_METHODS.map((method, idx) => (
                <Button
                    sx={{width:{xs:'200px', md:'200px'}, minHeight:{xs:'auto', md:'130px'}, border:'2px solid #FE686F',
                    ...pillButtonSx(selectedDeliveries.includes(method.value))}}
                    key={method.value}
                    fullWidth
                    disabled={
                        !selectedDeliveries.includes(method.value) &&
                        selectedDeliveries.length >= 3
                    }
                    onClick={() => {
                        if (selectedDeliveries.includes(method.value)) {
                            setSelectedDeliveries(selectedDeliveries.filter(v => v !== method.value));
                        } else if (selectedDeliveries.length < 3) {
                            setSelectedDeliveries([...selectedDeliveries, method.value]);
                        }
                    }}
                >
                    {method.label}
                </Button>
            ))}
            </Box>
            {selectedDeliveries.includes(8) && (
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Please specify other teaching method"
                    value={bestDeliveryOther}
                    onChange={(e) => setBestDeliveryOther(e.target.value)}
                    sx={{
                        my: 2,
                        width: '55%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#FF686f',
                            },
                            '&:hover fieldset': {
                                borderColor: '#FF686f',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#FF686f',
                            },
                        },
                    }}
                />
            )}
            <Button
                sx={{width:{xs:'200px'}, padding: "12px 24px !important", borderRadius:'20px', marginLeft:'auto', marginRight:'auto',
                ...pillButtonSx(true)}}
                disabled={selectedDeliveries.length === 0 && !bestDeliveryOther}
                onClick={() => {
                    setWizard(w => ({
                        ...w,
                        BestDelivery: selectedDeliveries,
                        BestDeliveryOther: bestDeliveryOther
                    }));
                    completeFormStep(14, [...selectedDeliveries.map(val => TEACHING_METHODS.find(f => f.value === val)?.label), bestDeliveryOther].filter(Boolean).join(', '));
                    if(editingFromSummary) {
                        ensureSummaryStepInChat();
                        return;
                    }
                    pushBotMsg("Are there any cultural/social sensitivities to consider?");
                    addFormStep(15);
                }}
            >SUBMIT</Button>
        </Box>
    );

    // --- STEP 15 ---
    const renderStep15 = () => (
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2 }}>Select sensitivities to consider:</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: {xs:'center', md:'flex-start'}, gap: 2 }}>
                {SENSITIVITIES.map((item, idx) => {
                    const isNoneOption = item.value === 5;
                    const noneSelected = selectedSensitivities[4] === 1;
                    const othersSelected = selectedSensitivities.some((val, i) => i !== 4 && val === 1);
                    const isDisabled = (isNoneOption && othersSelected) || (!isNoneOption && noneSelected);
                    return (
                    <Button
                            key={item.value}
                            style={{
                                width: '200px',
                                minHeight: '120px',
                                border: '2px solid #FE686F',
                                opacity: isDisabled ? 0.5 : 1,
                                borderColor: isDisabled ? '#666' : '#ff7a80',
                                pointerEvents: isDisabled ? 'none' : 'auto',
                            }}
                            fullWidth
                            sx={pillButtonSx(selectedSensitivities[idx] === 1)}
                            onClick={() => {
                                if (isDisabled) return;
                                const updated = [...selectedSensitivities];
                                updated[idx] = updated[idx] === 1 ? 0 : 1; // toggle
                                setSelectedSensitivities(updated);
                            }}
                        >
                            {item.label}
                        </Button>
                    );
                })}
            </Box>

            {selectedSensitivities[5] === 1 && ( // index 5 is "Others"
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="If other, specify"
                    value={culturalOther}
                    onChange={(e) => setCulturalOther(e.target.value)}
                    sx={{
                        my: 2,
                        width: '45%',
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: '#FE686F' },
                            '&:hover fieldset': { borderColor: '#FE686F' },
                            '&.Mui-focused fieldset': { borderColor: '#FE686F' },
                        },
                    }}
                />
            )}

            <Button
                sx={{ width: {xs:'200px'}, borderRadius:'20px', marginLeft: 'auto', marginRight: 'auto',
                    ...pillButtonSx(true)
                    }}
                disabled={selectedSensitivities.every(v => v === 0) && !culturalOther}
                onClick={() => {
                    setWizard(w => ({
                        ...w,
                        CulturalSensitivity: selectedSensitivities,
                        CulturalSensitivityOther: culturalOther,
                        CulturalSensitivityDetails: culturalDetail
                    }));

                    const selectedLabels = SENSITIVITIES
                        .map((s, i) => (selectedSensitivities[i] === 1 ? s.label : null))
                        .concat(culturalOther || [])
                        .filter(Boolean)
                        .join(', ');

                    completeFormStep(15, selectedLabels);

                    const needsContext = selectedSensitivities.some((val, idx) =>
                        val === 1 && [0, 1, 2, 3, 5].includes(idx) // index-based check
                    );

                    if (needsContext) {
                        pushBotMsg(
                            "<b>Thank you!\n\n Since you selected one or more sensitivities, could you please share a bit more context to help us design the session respectfully?</b>\n\n Examples:\n• \"Avoid political topics\"\n• \"Use visuals appropriate for Islamic schools\"\n• \"Respect norms about boys and girls working in separate groups\"\n• \"We avoid asking students to submit photos, especially those with faces or names visible.\""
                        );
                        addFormStep(151);
                    } else {
                        if (summaryEditInProgress) {
                            setEditingFromSummary(false);
                            setSummaryEditInProgress(false);
                            ensureSummaryStepInChat();
                            return;
                        }
                        pushBotMsg("Please review your program details and submit.");
                        addFormStep(16);
                    }
                }}
            >
                SUBMIT
            </Button>
        </Box>
    );

    // --- STEP 151 ---
    const renderStep151 = () => (
        <Box sx={{ mt: 2, width:'100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    background: '#fff',
                    border: '2px solid #ff7043',
                    borderRadius: '30px',
                    p: '5px 15px',
                    mt: 2,
                }}
            >
                <TextField
                    value={culturalDetail}
                    onChange={e => setCulturalDetail(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && culturalDetail.trim()) {
                            setWizard(w => ({ ...w, CulturalSensitivityDetails: culturalDetail }));
                            completeFormStep(151, culturalDetail);

                            if (summaryEditInProgress) {
                                setEditingFromSummary(false);
                                setSummaryEditInProgress(false);
                                ensureSummaryStepInChat();
                                return;
                            }
                            pushBotMsg("Please review your program details and submit.");
                            addFormStep(16);
                        }
                    }}
                    placeholder="Type your context here..."
                    fullWidth
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{ minWidth: 0 }}
                />
                <IconButton
                    onClick={() => {
                        setWizard(w => ({ ...w, CulturalSensitivityDetails: culturalDetail }));
                        completeFormStep(151, culturalDetail);

                        if (summaryEditInProgress) {
                            setEditingFromSummary(false);
                            setSummaryEditInProgress(false);
                            ensureSummaryStepInChat();
                            return;
                        }
                        pushBotMsg("Please review your program details and submit.");
                        addFormStep(16);
                    }}
                    disabled={!culturalDetail.trim()}
                    sx={{
                        color: 'white !important',
                        backgroundColor: '#EE6628 !important',
                        '&:hover': {
                            backgroundColor: '#EE6628 !important',
                        },
                        padding: '10px !important',
                        borderRadius: '50% !important',
                    }}
                >
                    <ArrowUpward />
                </IconButton>
            </Box>
        </Box>
    );

    // --- STEP 16 ---
    const renderStep16 = () => (
        <Box sx={{ mt: 2, mx: 'auto', p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Thank you! Based on your responses, here’s a summary of your program design. Please review carefully. If you'd like to edit any section, you can return to that step to make changes by clicking the pencil edit button.
            </Typography>

            {/* Country */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600} sx={{ mr: 1 }}>Country Context:</Typography>

                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body1">
                        Your target country/region is: {REGIONS.find(r => r.value === wizard.Countries)?.label || wizard.Countries}
                    </Typography>
                    <IconButton
                        className={classes.editIcon}
                        size="small"
                        onClick={() => handleEditFromSummary(3)}
                        sx={{ ml: 0.5, color: "#EE6628" }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Typography variant="body1">
                    We will align your program with the relevant <Typography component="span" sx={{ fontWeight: 'bold' }}>national and international frameworks:</Typography>
                </Typography>
                <ul style={{ marginTop: '4px', marginBottom: '0', paddingLeft: '20px' }}>
                    <li> <Typography variant="body1" component="span">IEEE DQ Global Standards (IEEE3527.1)</Typography></li>
                    <li> <Typography variant="body1" component="span">UNESCO</Typography></li>
                </ul>
            </Box>

            {/* Age */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600}>Learner Age Group:</Typography>
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body1">
                        Your target age group is: {TARGET_AGE.find(a => a.value === wizard.Age)?.label || wizard.Age}
                    </Typography>
                    <IconButton
                        className={classes.editIcon}
                        size="small"
                        onClick={() => handleEditFromSummary(2)}
                        sx={{ ml: 0.5, color: "#EE6628" }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            {/* Theme & Competencies */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600}>Learning Themes & Competencies</Typography>
                <Typography variant="body1">
                    You are developing an AI Literacy program with the following:
                </Typography>
                <ul>
                    <li><Typography variant="body1"><strong>Theme:</strong> {wizard.Theme}</Typography></li>
                    <li> <Typography variant="body1"><strong>Competencies Selected:</strong>
                            {wizard.Competencies?.length > 0 ? (
                                <ul>
                                    {wizard.Competencies.map((code) => {
                                        const competency = detectedCompetencies.find((item) => item.code === code);
                                        return (
                                            <li> <Typography variant="body1" component="span" key={code}>
                                                {code} - {competency?.title || 'Unknown Title'}
                                            </Typography>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                'No competencies selected'
                            )}
                        </Typography>
                    </li>
                </ul>
            </Box>

            {/* Focus */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600} display="inline">
                    Learning Focus Areas:
                </Typography>
                <IconButton
                    className={classes.editIcon}
                    size="small"
                    onClick={() => handleEditFromSummary(10)}
                    sx={{ ml: 0.5, color: "#EE6628" }}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
                <Typography variant="body1">
                    The selected competencies will be taught with the following focus areas:
                </Typography>
                <br/>
                <ul style={{ marginTop: '4px', marginBottom: 0, paddingLeft: '40px' }}>
                    <li>
                        <strong>Primary focus:</strong>{" "}
                        <ul style={{ margin: 0, paddingLeft: '20px' }}>
                            {[
                                { key: 'FocusProblem', label: 'Understanding the problems and issues related to the topic' },
                                { key: 'FocusSolution', label: 'Exploring responses and solutions' },
                                { key: 'FocusMindset', label: 'Encouraging a positive mindset' },
                            ].map((item, index) => {
                                const value =
                                    ['Not Important At All', 'Important', 'Very Important'][(wizard[item.key] ?? 0) - 1] || 'Not set';

                                return (
                                    <li key={index}>
                                        <Typography variant="body1" component="span">
                                        {item.label}:{' '}
                                        <span style={{ fontWeight: 'bold', color: '#0097a7' }}>{value}</span>
                                        </Typography>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                    <li>
                        <strong>Knowledge and skills emphasis:</strong>
                        <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                            {[
                                { key: 'FocusKS_F', label: 'Raising awareness and acquiring factual knowledge' },
                                { key: 'FocusKS_C', label: 'Gaining conceptual understanding' },
                                { key: 'FocusKS_P', label: 'Developing practical and procedural skills' },
                                { key: 'FocusKS_M', label: 'Building metacognitive and higher-order thinking skills' },
                            ].map(item => {
                                const value =
                                    ['Not Important At All', 'Important', 'Very Important'][(wizard[item.key] ?? 0) - 1] || 'Not set';
                                return (
                                    <li key={item.key}>
                                        <Typography variant="body1" component="span">
                                        {item.label}:{" "}
                                        <span style={{ fontWeight: 'bold', color: '#0097a7' }}>{value}</span>
                                        </Typography>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                    <li>
                        <strong>Mindset emphasis:</strong>
                        <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                            {[
                                { key: 'FocusAB_A', label: 'Shaping positive attitudes' },
                                { key: 'FocusAB_P', label: 'Strengthening values and beliefs' },
                                { key: 'FocusAB_I', label: 'Discovering learners’ intentions and willingness to change' },
                                { key: 'FocusAB_B', label: 'Encouraging self-reflection and behavioral habits' },
                            ].map(item => {
                                const value = ['Not Important At All', 'Important', 'Very Important'][(wizard[item.key] ?? 0) - 1] || 'Not set';
                                return (
                                    <li key={item.key}>
                                        <Typography variant="body1" component="span">
                                        {item.label}:{" "}
                                        <span style={{ fontWeight: 'bold', color: '#0097a7' }}>
                                          {value}
                                        </span>
                                        </Typography>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                </ul>
            </Box>

            {/* Context */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600} display="inline">
                    Learning Context:
                </Typography>
                <IconButton
                    className={classes.editIcon}
                    size="small"
                    onClick={() => handleEditFromSummary(11)}
                    sx={{ ml: 0.5, color: "#EE6628" }}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
                <Typography variant="body1">
                    <strong>Prior Exposure:</strong> {['None', 'Informal', 'Formal', 'Uncertain'][wizard.ExposureTopic - 1] || 'Not set'}
                    {wizard.ExposureTopicDetail && ` – ${wizard.ExposureTopicDetail}`}
                </Typography>
                <Typography variant="body1">
                    <strong>Cultural Considerations:</strong> {Array.isArray(wizard.CulturalSensitivity)
                    ? wizard.CulturalSensitivity
                        .map((flag, idx) => (flag === 1 ? SENSITIVITIES[idx]?.label : null))
                        .filter(Boolean)
                        .join(', ')
                    : ''}
                    {wizard.CulturalSensitivityOther && ` – ${wizard.CulturalSensitivityOther}`}
                </Typography>
            </Box>

            {/* Curriculum Type */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600} display="inline">
                    Curriculum Type:
                </Typography>
                <IconButton
                    className={classes.editIcon}
                    size="small"
                    onClick={() => handleEditFromSummary(4)}
                    sx={{ ml: 0.5, color: "#EE6628" }}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    Your AI Literacy program will be{" "}
                    <span style={{fontWeight: 600 }}>
                        {CURRICULUM_TYPE_LABELS[wizard.CurriculumType] || "Not specified"}
                    </span>
                    {wizard.SubjectAreaOther
                        ? `, specifically: ${wizard.SubjectAreaOther}`
                        : wizard.SubjectArea
                            ? `, specifically: ${SUBJECTS.find(s => s.value === wizard.SubjectArea)?.label}`
                            : ""}
                </Typography>

            </Box>

            {/* Structure */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600} component="span">
                    Program Structure
                </Typography>
                <IconButton
                    className={classes.editIcon}
                    size="small"
                    onClick={() => handleEditFromSummary(7)}
                    sx={{ ml: 0.5, color: "#FE686F" }}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
                <ul style={{ margin: 0, marginTop: 4, paddingLeft: 20 }}>
                    <li>
                        <Typography variant="body1" component="span">
                            You will develop a{" "}
                            <span style={{fontWeight: 600, textDecoration: "none", cursor: "pointer" }}>
                                {wizard.StructureType === 1
                                    ? "single-session program"
                                    : wizard.StructureType === 2
                                        ? "multi-session program"
                                        : "suggested structure"
                                }
                            </span>
                            {wizard.StructureType === 2 && wizard.NumSessions
                                ? ` (${wizard.NumSessions} sessions)`
                                : ""}
                            {" "}with a duration of{" "}
                            <span style={{fontWeight: 600 }}>
                                {wizard.SessionDuration
                                    ? `${wizard.SessionDuration} minutes per session`
                                    : "not specified"}
                            </span>.
                        </Typography>
                    </li>
                </ul>
            </Box>

            {/* Format */}
            <Box sx={{ mb: 2 }}>
                <Typography fontWeight={600}>
                    Program Format & Delivery Methods (Preferred format(s) of your program):
                    <IconButton
                        className={classes.editIcon}
                        size="small"
                        onClick={() => handleEditFromSummary(12)}
                        sx={{ ml: 0.5, color: "#FE686F" }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Typography>
                {wizard.Format?.map((selected, idx) => {
                    if (!selected) return null;
                    const format = DELIVERY_FORMATS[idx];
                    if (!format) return null;
                    return (
                        <Box key={idx} sx={{ ml: 1, mb: 1 }}>
                            <Typography
                                variant="body1"
                                component="div"
                                fontWeight={700}
                                sx={{
                                    display: "inline"
                                }}
                            >
                                {format.group}:
                            </Typography>
                            <Typography variant="body1" component="span" sx={{ fontWeight: 500, ml: 0.5 }}>
                                {format.label}
                            </Typography>
                            <br/>
                            <Box sx={{ ml: 3 }}>
                                {format.techEnvironment && (
                                    <Typography variant="body1" component="div">
                                        <span style={{ fontWeight: 600 }}>Tech Environment:</span> {format.techEnvironment}
                                    </Typography>
                                )}
                                {format.learningGoal && (
                                    <Typography variant="body1" component="div">
                                        <span style={{ fontWeight: 600 }}>Learning Goal:</span> {format.learningGoal}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    );
                })}
                {wizard.FormatOther && (
                    <Box sx={{ ml: 1 }}>
                        <Typography variant="body1">Other: {wizard.FormatOther}</Typography>
                    </Box>
                )}
            </Box>

            <Box>
                <Typography fontWeight={600}>
                    Preferred Delivery method(s)
                    <IconButton
                        className={classes.editIcon}
                        size="small"
                        onClick={() => handleEditFromSummary(14)}
                        sx={{ ml: 0.5, color: "#FE686F" }}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Typography>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {wizard.BestDelivery.map((val, i) =>
                        <li> <Typography variant="body1" component="span" key={i}>{TEACHING_METHODS.find(m => m.value === val)?.label}</Typography></li>
                    )}
                    {wizard.BestDeliveryOther && <li ><Typography variant="body1" component="span">{wizard.BestDeliveryOther}</Typography></li>}
                </ul>
            </Box>


            <Typography sx={{ mb: 2, mt: 2 }}>
                <strong>
                    If all the above information looks correct, please press “PROCEED” to generate your Program Outline and Syllabus.
                </strong>
                {" "}
                <span style={{ fontWeight: 400 }}>
                    If you’d like to make changes, you can select the section(s) to revise. If you would like to completely start over, click “START OVER”.
                </span>
            </Typography>


            <Box sx={{ display: 'flex',flexWrap:{xs:'wrap', md:'nowrap'},gap:{xs:'20px', md:'auto'}, justifyContent: 'space-between', mt: 3 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenStartOverDialog(true)}
                        sx={{ width:'200px', height:'50px', fontSize:'17px',borderRadius:'20px',borderColor: '#0095b6', color: '#0095b6' }}
                        disabled={step === 17} // Optional: disable if already at step 17
                        style={{ display: step === 17 ? 'none' : undefined }} // Hide if step 17
                    >
                        START OVER
                    </Button>
                {!editingFromSummary && !isEditing && step !== 17 && (
                    <Button
                        onClick={() => {
                            // completeFormStep(16, 'Program summary reviewed');
                            // Push a new chat message for step 17
                            pushBotMsg('', { formStep: 17, isActive: true });
                            setStep(17);
                        }}
                        sx={{ bgcolor: '#FE686F',width:'200px',borderRadius:'20px', height:'50px', fontSize:'17px', color: '#fff', '&:hover': { bgcolor: '#FE686F', color: '#fff' } }}
                        disabled={step === 17} // Optional: disable if already at step 17
                        style={{ display: step === 17 ? 'none' : undefined }} // Hide if step 17
                    >
                        PROCEED
                    </Button>
                )}
                </Box>
        </Box>
    );

    // --- STEP 17 ---
    const renderStep17 = () => (
        <Box sx={{ mt: 2, mx: 'auto', textAlign: 'left', p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                You’re now ready to move on to the <span style={{color:'#0095b6'}}>Program Outline and Syllabus</span> Generation stage.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                With the <a href="https://storage.googleapis.com/poweredbydq/assets/docs/PbDQ%20Framework%20for%20AI%20Literacy%20Curriculum%20Design.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: '#ff6000',
                    textDecoration: 'underline',
                    fontWeight: 'bold'
                }}
            >Powered by DQ Framework for AI Literacy Curriculum Design</a>,
                your program will be built on a strong foundation of <strong>educational psychology</strong> and <strong>proven
                curriculum design principles</strong>. You’ll be applying research-based strategies such as <strong>active
                learning, social-emotional learning,</strong> and <strong>progressive cognitive development</strong> to create
                an engaging, future-ready learning experience.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
                This isn’t just about teaching technology—it’s about <strong>empowering learners</strong> to see AI in
                the context of their own lives, think critically about its impact, and act with responsibility
                and integrity in an AI-driven world.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
                Your program will be:
                <ul style={{ marginTop: '8px', marginBottom: '8px', listStyleType:'disc', paddingLeft:'40px' }}>
                    <li><span style={{color:'#0097a7',fontWeight:'bold'}}>Developmentally aligned</span> to your learners’ needs</li>
                    <li><span style={{color:'#0097a7',fontWeight:'bold'}}>Relevant</span> to their everyday experiences</li>
                    <li><span style={{color:'#0097a7',fontWeight:'bold'}}>Integrated</span> across subjects for deeper learning connections</li>
                    <li><span style={{color:'#0097a7',fontWeight:'bold'}}>Hands-on</span> and goal-focused, with clear, age-appropriate outcomes</li>
                </ul>
            </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
                Here’s the structure we’ll build together:
                <ul style={{ marginTop: '8px', marginBottom: '8px',listStyleType:'decimal',paddingLeft:'40px' }}>
                    <li><strong style={{color:'#0097a7'}}>Course Description</strong> – A clear overview of the course vision and intended outcomes</li>
                    <li><strong style={{color:'#0097a7'}}>Modules</strong> – The main pillars of the course, aligned to your teaching objectives</li>
                    <li><strong style={{color:'#0097a7'}}>Units</strong> – Logical clusters of sessions within each module</li>
                    <li><strong style={{color:'#0097a7'}}>Sessions</strong> – Short (under 1 hour) lessons, each with three tangible student outcomes</li>
                </ul>
            </Typography>

            <Typography variant="body1" sx={{ mb: 3, fontWeight:'bold' }}>
                Shall we proceed?
            </Typography>

            <Button
                style={{ width: '200px', height: '50px', fontSize: '17px' }}
                onClick={handleProgramCompletion}
                sx={{
                    bgcolor: '#FE686F',
                    color: '#fff',
                    borderRadius: '20px',
                    '&:hover': {
                        bgcolor: '#FE686F',
                        color: '#fff',
                    },
                }}
            >
                NEXT
            </Button>
        </Box>

    );

    // Initial chat: user types topic -> after stream, call addFormStep(1, renderAgeStep());
    const handleInputKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage(input);
        }
    };
    const handleSendClick = () => sendMessage(input);

    const sendMessage = async (user_message) => {
        if (!user_message.trim()) return;
        setShowChat(true);
        setInput('');
        setChatInitiated(true);

        let currentProgramId = programIdState;
        if (!currentProgramId) {
            setShowLoader(true);
            try {
                const result = await createProgramService();
                if (result?.data?.program_id) {
                    currentProgramId = result.data.program_id;
                    setProgramIdState(currentProgramId);
                    setShowLoader(false);
                    await actuallySendMessage(currentProgramId, user_message);
                    return;
                }
            } catch (e) {
                setShowLoader(false);
                return;
            }
        } else {
            await actuallySendMessage(currentProgramId, user_message);
        }
    };

    // Service: stream bot response, parse competencies, then step forward
    const actuallySendMessage = async (programId, user_message) => {
        pushUserMsg(user_message);
        setIsBotThinking(true);
        try {
            setWizard(w => ({
                ...w,
                CourseCode: programId
            }));
            const response = await CurationPromptStreamService(programId, user_message);
            if (!response.ok) throw new Error('Network response was not ok');
            if (!response.body) throw new Error('Readable stream not supported in your browser.');
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let botMessage = '';
            let doneStreaming = false;
            let detected_competencies = undefined;

            while (!doneStreaming) {
                const { done, value } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value);
                const lines = chunk.split('data: ');
                for (let line of lines) {
                    const content = line;
                    if (content === '[DONE]') {
                        setIsBotThinking(false);
                        doneStreaming = true;
                        break;
                    } else {
                        botMessage += content;
                        // If we find competencies, extract and move forward!
                        if (botMessage.includes("{{redirect_to_form=true}}")) {
                            botMessage = botMessage.replace("{{redirect_to_form=true}}", "");
                            const marker = "{{detected_competencies=";
                            const themeMarker = "{{theme=";
                            const start = botMessage.indexOf(marker);
                            if (start !== -1) {
                                const valueStart = start + marker.length;
                                const valueEnd = botMessage.indexOf("}}", valueStart);
                                if (valueEnd !== -1) {
                                    const encoded = botMessage.substring(valueStart, valueEnd);
                                    try {
                                        detected_competencies = JSON.parse(decodeURIComponent(encoded));
                                        setDetectedCompetencies(detected_competencies.Competencies); // Store full objects
                                        console.log("Detected Competencies:", detected_competencies);
                                        // Extract just the codes for the wizard state
                                        const competencyCodes = detected_competencies.Competencies.map(comp => comp.code);
                                        setWizard(w => ({
                                            ...w,
                                            Competencies: competencyCodes || []
                                        }));
                                    } catch (e) {
                                        detected_competencies = undefined;
                                    }
                                    botMessage = botMessage.replace(`${marker}${encoded}}}`, "");
                                }
                            }
                            // Extract theme
                            const themeStart = botMessage.indexOf(themeMarker);
                            if (themeStart !== -1) {
                                const themeValueStart = themeStart + themeMarker.length;
                                const themeValueEnd = botMessage.indexOf("}}", themeValueStart);
                                if (themeValueEnd !== -1) {
                                    const encodedTheme = botMessage.substring(themeValueStart, themeValueEnd);
                                    const theme = decodeURIComponent(encodedTheme);
                                    setWizard(w => ({
                                        ...w,
                                        Theme: theme
                                    }));
                                    botMessage = botMessage.replace(`${themeMarker}${encodedTheme}}}`, "");
                                }
                            }
                            setChatHistory(prev => [
                                ...prev,
                                {
                                    type: CHAT_TYPE.BOT,
                                    text: "Based on your input, here are the detected AI competencies for your program:",
                                    renderTable: true,
                                    tableData: detected_competencies?.Competencies || [],
                                },
                            ]);
                            // // Then trigger age step form
                            // pushBotMsg("Please select the age group for your program.");
                            // addFormStep(2);
                            // setStep(2);
                        }
                        setChatHistory(prev => {
                            if (prev.length > 0 && prev[prev.length - 1].type === CHAT_TYPE.BOT) {
                                const updated = [...prev];
                                updated[updated.length - 1].text = botMessage;
                                return updated;
                            } else {
                                return [...prev, { type: CHAT_TYPE.BOT, text: botMessage }];
                            }
                        });
                        if (detected_competencies) {
                            pushBotMsg("Please select the age group for your program.");
                            addFormStep(2);
                            setStep(2);
                        }
                    }
                }
            }
            setIsBotThinking(false);
        } catch (e) {
            setIsBotThinking(false);
        }
    };

    if (showLoader) return <Loader />;

    return (
        <Box className={classes.pageContainer}>
            {/* Start Over confirmation dialog */}
            <Dialog open={openStartOverDialog} onClose={() => setOpenStartOverDialog(false)} fullWidth maxWidth="sm" PaperProps={{ sx:{ border:'2px solid #000', borderRadius:'15px' } }}>
                <Box sx={{ p:4, position:'relative' }}>
                    <IconButton
                        aria-label="close"
                        onClick={() => setOpenStartOverDialog(false)}
                        sx={{ position:'absolute', right:8, top:8, color:'#999' }}
                    >
                        <EditIcon sx={{ display:'none' }} />{/* placeholder to keep imports; replace with CloseIcon if available */}
                    </IconButton>
                    <Typography variant="h6" sx={{ mt:2, mb:4, textAlign:'center', color:'#ff5757' }}>
                        Are you sure you want to remove this program?<br/>This action cannot be undone.
                    </Typography>
                    <Box sx={{ display:'flex', flexDirection:{ xs:'column', sm:'row'}, alignItems:'center', justifyContent:'center', gap:2, width:'100%', mt:2 }}>
                        <Button
                            variant="contained"
                            sx={{ width:{ xs:'100%', sm:'40%'}, fontSize:'15px !important', fontWeight:'bold', backgroundColor:'#ff5757', '&:hover':{ backgroundColor:'#ff5757' } }}
                            onClick={() => { setOpenStartOverDialog(false); handleStartOver(); }}
                        >
                            Yes, Remove
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{ width:{ xs:'100%', sm:'40%'}, fontSize:'15px !important', borderColor:'#ff5757', color:'#ff5757', fontWeight:'bold' }}
                            onClick={() => setOpenStartOverDialog(false)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Dialog>
            <Box className={classes.contentContainer}>
                <Typography variant="h2" className={classes.title} sx={{ mb: 2, mt:{md:'70px', lg: '0px'} }}>
                    Welcome to DQ Learning Creator!
                </Typography>
                {!chatInitiated && (
                    <Box>
                        <Typography variant="h5" sx={{ textAlign: "center", mb: 4 }}>
                            Let's begin designing your custom AI Literacy learning Program.<br />
                            To start please tell us about the main topic or theme you want to teach.
                        </Typography>
                        <Typography
                            variant="h5"
                            style={{ color: "#EE6D29", fontWeight: 500 }}
                        >
                            Examples:
                        </Typography>
                        <Typography
                            variant="h5"
                            style={{
                                marginBottom: "15px",
                                fontStyle: "italic",
                                color: "#EE6D29",
                            }}
                        >
                            "I want to create a program to teach about cyberbullying for Grade 5 students." <br />
                            "I want to explore AI Ethics with middle school learners."
                        </Typography>
                    </Box>
                )}
                <Box className={classes.chatContainer} id="chatbot-chat-area">
                    {chatHistory.map((chat, index) => {
                        const shouldRenderForm = chat.formStep && chat.isActive && renderFormStep(chat.formStep);
                        // Guard: don't render empty bot messages unless it's a form step or table
                        if (
                            chat.type === CHAT_TYPE.BOT &&
                            !chat.text?.trim() &&
                            !chat.renderTable &&
                            !shouldRenderForm
                        ) {
                            return null;
                        }

                        return (
                            <div
                                key={index}
                                ref={(el) => {
                                    chatRefs.current[index] = el;
                                    if (index === chatHistory.length - 1) {
                                        newMessageRef.current = el;
                                    }
                                }}                            >
                                {chat.type === CHAT_TYPE.USER ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row-reverse',
                                            alignItems: 'flex-end',
                                            mb: 2.5,
                                        }}
                                    >
                                        {/* User Avatar */}
                                        <Avatar
                                            sx={{
                                                bgcolor: '#FE686F',
                                                color: '#fff',
                                                width: 36,
                                                height: 36,
                                                ml: 1,
                                                fontSize: 22,
                                                fontFamily: 'Inter, sans-serif',
                                            }}
                                        >
                                            <PersonIcon />
                                        </Avatar>
                                        {/* User Bubble */}
                                        <Box
                                            sx={{
                                                background: '#fff',
                                                color: '#222',
                                                borderRadius: '18px',
                                                boxShadow: '0 2px 8px rgba(60,60,60,0.08)',
                                                px: 2.5,
                                                py: 1.7,
                                                maxWidth: 560,
                                                fontSize: 17,
                                                fontFamily: 'Inter, Roboto, Arial, sans-serif',
                                                wordBreak: 'break-word',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {chat.text}
                                            {chat.formStep >= 2 && (
                                                <IconButton
                                                    className={classes.editIcon}
                                                    size="small"
                                                    onClick={() => handleEditClick(index)}
                                                    sx={{ ml: 1, color: "#EE6628" }}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'flex-end',
                                            mb: 2.5,
                                        }}
                                    >
                                        {/* Bot Avatar */}
                                        <Avatar
                                            sx={{
                                                bgcolor: '#8A8DA8',
                                                color: '#fff',
                                                width: 36,
                                                height: 36,
                                                mr: 1,
                                                fontSize: 22,
                                                fontFamily: 'Inter, sans-serif',
                                            }}
                                        >
                                            <SmartToyIcon />
                                        </Avatar>
                                        {/* Bot Bubble */}
                                        <Box
                                            sx={{
                                                background: '#f7f7f8',
                                                color: '#222',
                                                borderRadius: '18px',
                                                boxShadow: '0 2px 8px rgba(60,60,60,0.07)',
                                                px: 2.5,
                                                py: 1.7,
                                                fontSize: 17,
                                                fontFamily: 'Inter, Roboto, Arial, sans-serif',
                                                wordBreak: 'break-word',
                                                textAlign: 'left',
                                                width: [6, 8, 10, 11, 101, 102, 111,151, 13, 121].includes(chat.formStep) ? '95%' : 'auto',
                                            }}
                                        >
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: parseMarkdown(chat.text),
                                                }}
                                            />
                                            {chat.renderTable && chat.tableData?.length > 0 && (
                                                <Box sx={{ mt: 2 }}>
                                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                        <thead>
                                                        <tr style={{ background: "#f5f5f5" }}>
                                                            <th style={{ border: "1px solid #ddd", padding: 10, textAlign: "left", width: 120 }}>
                                                                DQ Code
                                                            </th>
                                                            <th style={{ border: "1px solid #ddd", padding: 10, textAlign: "left", width: 120 }}>
                                                                Title
                                                            </th>
                                                            <th style={{ border: "1px solid #ddd", padding: 10, textAlign: "left" }}>
                                                                Description
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {chat.tableData?.map((competency, i) => (
                                                            <tr
                                                                key={i}
                                                                style={{
                                                                    background: i % 2 === 0 ? "#fff" : "#f9f9f9",
                                                                }}
                                                            >
                                                                <td style={{ border: "1px solid #ddd", padding: 10, width: 120 }}>
                                                                    {competency.code}
                                                                </td>
                                                                <td style={{ border: "1px solid #ddd", padding: 10 }}>
                                                                    {competency.title}
                                                                </td>
                                                                <td style={{ border: "1px solid #ddd", padding: 10 }}>
                                                                    {competency.description}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </Box>
                                            )}
                                            {shouldRenderForm ? renderFormStep(chat.formStep) : null}
                                        </Box>
                                    </Box>
                                )}
                            </div>
                        );
                    })}
                    {isBotThinking && (
                        <Box className={classes.thinkingIndicator}>
                            <CircularProgress size={18} style={{ marginRight: 8, color: '#FE686F' }} />
                            We're thinking...
                        </Box>
                    )}
                </Box>
                {step === 0 && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            // gap: "10px",
                            // background: "white",
                            borderRadius: "7px",
                            border:'2px solid #FFAB46',
                            // padding: "5px 15px",
                            // mt: 2,
                            width: {xs:'90%',md:'90%', lg:"70%"},
                        }}
                    >
                        <TextField
                            className={classes.inputField}
                            value={input}
                            multiline
                            maxRows={4}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={handleInputKeyDown}
                            disabled={isBotThinking}
                            placeholder="Type your message..."
                            variant="standard"
                            fullWidth
                            sx={{ flex: 1 }}
                            InputProps={{
                                disableUnderline: true,
                                style: { fontSize: "16px",paddingLeft:'15px'  },
                                endAdornment: (
                                    <IconButton
                                        className={classes.iconButton}
                                        onClick={handleSendClick}
                                        disabled={isBotThinking || !input.trim()}
                                    >
                                        <ArrowUpward />
                                    </IconButton>
                                ),
                            }}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default DQProProgCreationV2;
